/* @flow */

import { textColor } from '@e180/ui/lib/token/color';
import { antialiasing } from 'src/shared/app/base/style/token/helper';

export default {
  root: {
    backgroundColor: ({ accentColor }: Object) => accentColor,

    '&:hover': {
      backgroundColor: ({ darkAccentColor }: Object) => darkAccentColor,
    },
  },
  'root-withSuccess': {
    extend: antialiasing,

    color: textColor,
  },
};
